import React from 'react';
import {DieselRoute} from 'epic-diesel-common/src/hocs';
import Overview from './Overview';

class OverviewView extends React.Component {
    static propTypes = {};

    render() {
        return <Overview />;
    }
}

export default DieselRoute(OverviewView, {path: 'overview'});
